export const API_URL_USER = 'https://income-expenses-tracker-api.vercel.app/tracker-api/v1/users';

export const API_URL_ACCOUNT = 'https://income-expenses-tracker-api.vercel.app/tracker-api/v1/accounts';

export const API_URL_TRANSACTION = 'https://income-expenses-tracker-api.vercel.app/tracker-api/v1/transactions';
